import type { FaireProductEntity } from "../../entity_types/product";

export const p_mgv9v328tw: FaireProductEntity = {
  token: "p_mgv9v328tw",
  type: "product",
  name: "Women's Buttery Soft V-Neck with Capri Lounge Set",
  brandToken: "b_br6ji29u",
  brandName: "Softies",
  imageUrl: "https://cdn.faire.com/fastly/95c2c1c15d5b50bb746fc402e556ee4afbdf4326c8ca6061f669edc5ee5bb0c4.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/1835c22d0f6498a2c8b19d09ae84d1a4b5a9876f821e16528cc580b861348a2e.jpeg",
    "https://cdn.faire.com/fastly/ba537b4b7ddfcc3640aee74d9d05b2d16135e3cbf6ab280ba342522f21ccb182.png",
    "https://cdn.faire.com/fastly/844e4a518b63d16fe48a4eeb70410b88afb0d52443c2760e7b024a1c884be208.png",
    "https://cdn.faire.com/fastly/b1e29a66ece10c039d1150ae75ff39a3c3384e8512b96b8e0479e9a08278bf2f.png",
    "https://cdn.faire.com/fastly/0b0ff9749cab76280a1dbd900748df91dfd6e8fd54c154ce9db34c78caabe445.jpeg",
    "https://cdn.faire.com/fastly/07d2ec2050485ca9228d5285c6f108aa376756912da66be4184179c14c434d99.jpeg",
    "https://cdn.faire.com/fastly/b4b1bbf1ba29e91b742fa21fdb5162884eae815fefbbe5b55a35d766ed534a2a.jpeg",
    "https://cdn.faire.com/fastly/ddc006c4fa79f9f89d3942ef49c95b1d32cf56fcc5041a1a3dba70b4db0efffa.png",
    "https://cdn.faire.com/fastly/6363c44a877695cfc70e98416926cd70a734b4d854d75551c51e028d5936e197.jpeg",
    "https://cdn.faire.com/fastly/07a354f2e519a175972713235f66bb351e575ef3ed981dd64186759e725314a8.jpeg",
    "https://cdn.faire.com/fastly/2db1bc42dc3586608877b5f7c986e4ba9f21f5535e2f4edbbf414d9c05a2445c.jpeg",
    "https://cdn.faire.com/fastly/b33e9bf7d4ee92a2db209495f0ad95aa32997cb1bfbc005f8d8c02aa707304bd.png",
    "https://cdn.faire.com/fastly/b3e335604317989e77d419fb60b96a48c7e298b6cb995cbf0b7bd0c486952a3c.png",
    "https://cdn.faire.com/fastly/f45f79f57bcff80888796b4f623b0b456d908cd00a7c92e2c77858d2168b4f6d.png",
    "https://cdn.faire.com/fastly/664a68812bbf8cf31659a804a541105deac42e58d5a00f9cb36d4a1c613670a2.png",
    "https://cdn.faire.com/fastly/61e4f427085a755cd9378ab011a7e17092dcbed2daab2e32bd49cf6295511184.jpeg",
    "https://cdn.faire.com/fastly/1803b35f3d15695e5fb2166e06e85350c4bd06ba528009c9243fc35c074354ea.jpeg",
    "https://cdn.faire.com/fastly/3c95e8bd589c290aa1c69ce54e9fb61feadeec1ae578e4e39d91e84aaad8d64a.jpeg",
    "https://cdn.faire.com/fastly/930c4a84e0ed360db89622e8d8bd906d435ac7adc5cad94b0966c48a021bce64.jpeg",
    "https://cdn.faire.com/fastly/ce0cd5c9c316dba3678dce574c9695beddc654ec11dc700cf1ab8b965cced7f2.png"
  ],
  priceDollars: 60,
  description: "Lightweight and Soft V-neck Dream Capri Lounge Set\n\nThe perfect lounge wardrobe starts with Softies Dream V-neck Capri 2-piece matching set. Crafted from ultra-soft Dream jersey, the pair includes a dolman sleeve V-neck top and capri pants with an elastic waistband and two side pockets.\n\n𝐅𝐞𝐚𝐭𝐮𝐫𝐞𝐬\n\n• 24” inseam\n• Versatile, lightweight and luxuriously soft\n• Features dolman sleeves and feminine V-neck for relaxed fit\n• Capri makes the ideal look for every season",
  tags: [],
  msrpDollars: 130,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-09-02T03:47:07.555Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
